import { Injectable } from '@angular/core';

import { Odds, OddsComparerFactory, OddsOperations } from '@frontend/sports/odds/feature';

import { AccaBoostFilter, AccaBoostTokenMinOdds, CriteriaType, IRewardToken } from '../../../../reward-tokens.model';
import { TokenValidationInput, TokensCriteriaValidatorBase } from '../../criteria-validator-base.service';

@Injectable()
export class AccaBoostMinOddsValidator extends TokensCriteriaValidatorBase<IRewardToken, CriteriaType> {
    override type = CriteriaType.MinOdds;

    constructor(private oddsComparerFactory: OddsComparerFactory) {
        super();
    }

    isValid(token: IRewardToken, state: TokenValidationInput): boolean {
        const { minOddsPerLeg } = token.filter as AccaBoostFilter;
        const picks = state.selectedPicks;
        const minOdds = this.mapMinOdds(minOddsPerLeg);
        const minOddsComparer = this.oddsComparerFactory.createComparer(minOdds);

        return picks.every((p) => p.currentPrice && minOddsComparer.lessOrEqualThan(p.currentPrice.nativeOdds));
    }

    private mapMinOdds(minOddsPerLeg: AccaBoostTokenMinOdds): Odds {
        return OddsOperations.createOdds({
            odds: minOddsPerLeg?.european,
            numerator: minOddsPerLeg?.britishNumerator,
            denominator: minOddsPerLeg?.britishDenominator,
            americanOdds: minOddsPerLeg?.american,
        });
    }
}
